import { Button, Intent } from "@blueprintjs/core";
import { saveAs } from "file-saver";
import { FGDateMaskInput, FGSelectInput, FieldGroup, FieldSet, showError } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";
import * as Yup from "yup";

import { BroodRequesReportDetailDto, BroodRequestApi, FileDownload } from "../../api";
import { FGSRSHDateMaskInput, SmallFormGenerator } from "../../components";
import { useApiService, useTl } from "../../hooks";
import { useReferential } from "../../hooks/useReferential";
import { ETLCodes } from "../../locales/ETLCodes";
import { b64toBlob } from "../../utils";

export interface IPuppyReportProps {}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.75rem;
`;

export const PuppyReport: React.FunctionComponent<IPuppyReportProps> = (props) => {
  const { t } = useTl();
  const api = useApiService(BroodRequestApi);
  const [breeds, bloading] = useReferential((a) => a.getBreeds(null), true, []);
  const [saving, setsaving] = React.useState(false);
  const getDoc = React.useCallback(
    async (d: BroodRequesReportDetailDto) => {
      try {
        setsaving(true);
        console.log("data", d);
        var file = await api.getPuppyReport(d);
        if (file?.fileBytes) {
          var blob = b64toBlob(new FileDownload({ base64Content: file.fileBytes, fileName: file.fileName }));
          saveAs(blob, file.fileName);
        }
        setsaving(false);
      } catch {
        showError(t(ETLCodes.Error));
        setsaving(false);
      }
    },
    [api, t]
  );

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      dateFrom: Yup.date().nullable().required(t(ETLCodes.Required)),
      dateTo: Yup.date().nullable().required(t(ETLCodes.Required)),
    });
  }, [t]);

  return (
    <FieldSet title={t(ETLCodes.Puppies)}>
      <SmallFormGenerator
        initialValues={BroodRequesReportDetailDto.fromJS({})}
        onSubmit={getDoc}
        editMode={true}
        showDeleteButton={false}
        validationSchema={FormSchema}
        hideButtons={true}
      >
        <FieldGroup>
          <FGSRSHDateMaskInput name="dateFrom" label={t(ETLCodes.DateFrom)} />
          <FGSRSHDateMaskInput name="dateTo" label={t(ETLCodes.DateTo)} />
          <FGSelectInput name="breedId" label={t(ETLCodes.Breed)} items={breeds} loading={bloading} />
        </FieldGroup>
        <Container>
          <Button
            type={"submit"}
            text={t(ETLCodes.GenerateReport)}
            loading={saving}
            intent={Intent.PRIMARY}
            icon={<i className="far fa-file-excel" />}
          />
        </Container>
      </SmallFormGenerator>
    </FieldSet>
  );
};
